import React from 'react';
import { get as _get } from 'lodash-es';

import Layout from '../components/Layout';
import PartialsHeader from '../components/Partials/PartialsHeader';
import PartialsQuestion from '../components/Partials/PartialsQuestion';
import ResultsCategories from '../components/Results/ResultsCategories';
import ResultsRoll from '../components/Results/ResultsRoll';
import useCaseStudies from '../graphql/staticQueries/useCaseStudies';

class ResultsTemplate extends React.Component {
  state = {
    activeCategory: 'ALL'
  };

  setActiveCategory = cat => {
    const activeCategory = cat;
    this.setState({ activeCategory });
  };

  render() {
    const { categories, cases } = this.props;
    const { activeCategory } = this.state;
    const filteredCases =
      activeCategory === 'ALL'
        ? cases
        : cases.filter(result => {
            const cat = _get(
              result,
              'frontmatter.info.industry',
              ''
            ).toUpperCase();
            return cat === activeCategory;
          });
    return (
      <Layout
        title="Case studies | Ulam Labs"
        description="Building bespoke software is challenging. Our team of developers has the know-how and experience gained with our clients. Read our case studies."
      >
        <PartialsHeader>
          <div className="container">
            <div className="content">
              <div className="body">
                <h1 className="title">Case studies</h1>
              </div>
            </div>
          </div>
        </PartialsHeader>
        <div className="result-index">
          <ResultsCategories
            categories={categories}
            activeCategory={activeCategory}
            setActiveCategory={this.setActiveCategory}
          />
          <ResultsRoll cases={filteredCases} />
        </div>
        <PartialsQuestion />
      </Layout>
    );
  }
}

const ResultsDataParser = ({ location }) => {
  const cases = useCaseStudies();
  const categories = cases.reduce(
    (acc, item) => {
      const cat = item.frontmatter.info.industry.toUpperCase();
      if (!acc.includes(cat)) acc.push(cat);
      return acc;
    },
    ['ALL']
  );
  return (
    <ResultsTemplate
      cases={cases}
      categories={categories}
      location={location.href}
    />
  );
};
export default ResultsDataParser;
